import NsIllustration from '@britishgasenergy/react-nucleus/dist/nuc-components/NsIllustration';
import * as TOKENS from '@connectedhomes/nucleus/build/tokens/es6/tokens';

import NsContent from 'components/common/ns-content/NsContent';
import { TariffHighlight } from 'components/direct-sales/quote/components/TariffHighlight';
import { useTariffConfig } from 'components/direct-sales/quote/hooks/useTariffConfig';
import { NsPrice } from 'components/common/ns-price/NsPrice';
import { WrapText } from 'components/common/wrap-text/WrapText';

import type { TProduct } from 'api/models/TProduct';

type Props = {
  product?: TProduct;
  style?: React.CSSProperties;
  testId?: string;
};

export const HeaderTh = ({ product = {}, testId, style }: Props) => {
  const { name, annualAmount, monthlyAmount } = product;
  const { decoration, keyline } = useTariffConfig(product);
  const maxChars = 25;
  const primaryColors = ['cyan', 'lime', 'navy'];
  const colorType = primaryColors.includes(keyline) ? 'PRIMARY' : 'SECONDARY';

  const keylineStyle = keyline
    ? {
        'border-top-width': TOKENS.BORDER_SIZE_8PX,
        'border-top-color':
          TOKENS[`COLOR_${colorType}_${keyline?.toUpperCase()}`]
      }
    : {};

  return (
    <th
      scope="rowgroup"
      data-testid={testId}
      align="left"
      style={{ ...style, ...keylineStyle }}
    >
      <NsContent spacing="cosy">
        {decoration && <NsIllustration type={decoration} size="1" />}
        <h5>
          <WrapText wrap max={maxChars}>
            {name || ''}
          </WrapText>
        </h5>
        <TariffHighlight product={product} maxWrap={maxChars} />
        <div>
          <p>
            <span className="h3">
              <NsPrice amount={monthlyAmount} showDecimal />
            </span>
            <span className="p-caption"> / month</span>
          </p>
          <p>
            <span className="p-small">
              <NsPrice amount={annualAmount} showDecimal /> / year
            </span>
          </p>
        </div>
      </NsContent>
    </th>
  );
};
